"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var LeftPanelHeader = styled_components_1.default.h4(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: 500 !important;\n  font-size: 12px !important;\n  line-height: 133%;\n  letter-spacing: 0.0312em;\n  text-transform: uppercase;\n  color: #000000 !important;\n  margin-bottom: 20px !important;\n"], ["\n  font-weight: 500 !important;\n  font-size: 12px !important;\n  line-height: 133%;\n  letter-spacing: 0.0312em;\n  text-transform: uppercase;\n  color: #000000 !important;\n  margin-bottom: 20px !important;\n"])));
exports.default = LeftPanelHeader;
var templateObject_1;
